import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcBadHomeWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 11,
			r: 11,
			fill: "#CED2DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.91565 13.778C6.9145 13.7797 6.91333 13.7814 6.91216 13.7831C6.91242 13.7828 6.91276 13.7823 6.91321 13.7817C6.91607 13.7779 6.92288 13.7689 6.93397 13.7556C6.95614 13.729 6.9955 13.6848 7.05486 13.6286C7.17331 13.5164 7.37283 13.3548 7.67698 13.1889C8.28274 12.8585 9.32372 12.5 11.0001 12.5C12.6764 12.5 13.7174 12.8585 14.3231 13.1889C14.6273 13.3548 14.8268 13.5164 14.9452 13.6286C15.0046 13.6848 15.044 13.729 15.0661 13.7556C15.0772 13.7689 15.084 13.7779 15.0869 13.7817C15.0873 13.7823 15.0877 13.7828 15.088 13.7831C15.2425 14.0082 15.5496 14.0679 15.7774 13.916C16.0072 13.7628 16.0693 13.4524 15.9161 13.2226L15.5001 13.5C15.9161 13.2226 15.9159 13.2223 15.9156 13.222L15.9152 13.2213L15.9141 13.2197L15.9118 13.2163L15.9059 13.2078C15.9014 13.2014 15.8958 13.1936 15.889 13.1846C15.8755 13.1665 15.8574 13.1432 15.8344 13.1155C15.7882 13.06 15.7221 12.987 15.633 12.9026C15.4546 12.7336 15.1853 12.5202 14.802 12.3111C14.0327 11.8915 12.8237 11.5 11.0001 11.5C9.17638 11.5 7.96737 11.8915 7.19813 12.3111C6.81477 12.5202 6.54554 12.7336 6.36712 12.9026C6.27804 12.987 6.21193 13.06 6.16575 13.1155C6.14266 13.1432 6.12456 13.1665 6.11107 13.1846C6.10433 13.1936 6.09873 13.2014 6.09424 13.2078L6.08833 13.2163L6.08598 13.2197L6.08495 13.2213L6.08448 13.222C6.08425 13.2223 6.08403 13.2226 6.50005 13.5L6.08403 13.2226C5.93085 13.4524 5.99294 13.7628 6.2227 13.916C6.45052 14.0679 6.75766 14.0081 6.91216 13.7831C6.91158 13.7839 6.91148 13.7841 6.91182 13.7836L6.91326 13.7815L6.9145 13.7797L6.91525 13.7786L6.91565 13.778ZM15.0849 13.7787L15.0856 13.7797L15.0868 13.7815L15.0883 13.7836C15.0886 13.7841 15.0885 13.7839 15.088 13.7831",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 9,
			r: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 9,
			r: 1,
			fill: "white"
		})
	]
});
export default SvgIcBadHomeWhite;
